import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/plugin/utc';
import 'dayjs/plugin/duration';
import 'dayjs/plugin/timezone';
import 'dayjs/locale/en-au';
import 'dayjs/locale/en-nz';

const dayjsExt = dayjs;

dayjs.extend(require('dayjs/plugin/utc'));
dayjs.extend(require('dayjs/plugin/duration'));
dayjs.extend(require('dayjs/plugin/timezone'));

export { dayjsExt, Dayjs };